import React from 'react';

import styles from './Spinner.module.css';

export const Spinner = () => {
  return (
    <div className={styles.ldsRoller}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
